exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-5b76262e], h3[data-v-5b76262e] {\n    font-weight: bold !important;\n}\n.inner-content-vi[data-v-5b76262e] {\n    font-family: \"Arial\", Georgia, serif;\n}\n.inner-content-vi h2[data-v-5b76262e] {\n    font-size: 1.6rem !important;\n}\n.inner-content-vi h3[data-v-5b76262e]{\n    font-size: 1.5rem !important;\n}\n.inner-content-vi p[data-v-5b76262e]{\n    font-size: 1.3rem !important;\n}\n", ""]);

// exports
